import React, { FC, useCallback, useState } from 'react';
import { IonPage, RefresherEventDetail, useIonViewDidEnter } from '@ionic/react';
import {
  AppHeader_v2 as AppHeader,
  Container_v2 as Container,
  IconButton,
  IconLeftArrow,
  Typography,
  TypographyVariantsEnum,
  Refresher,
} from '@mindly/ui-components';
import { RouteComponentProps } from 'react-router';
import EmptyCouponsAndPromoCodes from './EmptyCouponsAndPromoCodes';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../redux/user/selector';
import DiscountItemLoader from './CouponItemLoader';
import { useTranslation } from 'react-i18next';
import { fetchPromoCodes } from '../../redux/promoCodes/promoCodes.thunk';
import { selectPromoCodes } from '../../redux/promoCodes/promoCodes.selectors';
import PromoCodeList from './PromoCodesList/PromoCodesList';
import useToast from '../../context/ToastContext/ToastContext';

const PromoCodesAndCoupons: FC<RouteComponentProps> = ({ history }) => {
  const currentUser = useSelector(userSelector);
  const { t } = useTranslation('profile');
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const promoCodes = useSelector(selectPromoCodes);

  const fetchDiscounts = useCallback(
    (options: { isRefresher: boolean }) => async (event?: CustomEvent<RefresherEventDetail>) => {
      if (!currentUser?.id) return;
      try {
        !options.isRefresher && setIsLoading(true);
        await dispatch(
          fetchPromoCodes({
            client_id: currentUser.id,
          })
        );
      } catch (error) {
        showToast({
          error,
        });
      } finally {
        event?.detail?.complete();
        !options.isRefresher && setIsLoading(false);
      }
    },
    [currentUser?.id]
  );

  useIonViewDidEnter(async () => {
    await fetchDiscounts({ isRefresher: false })();
  }, [fetchDiscounts]);

  return (
    <IonPage>
      <AppHeader>
        <IconButton icon={<IconLeftArrow />} onClick={() => history.go(-1)} />
      </AppHeader>
      <Container isFlexContainer>
        <Typography variant={TypographyVariantsEnum.Title28Semi} className={'mb-6'}>
          {t('discounts.title')}
        </Typography>
        <Refresher onIonRefresh={fetchDiscounts({ isRefresher: true })} disabled={isLoading} />
        {isLoading ? (
          <DiscountItemLoader />
        ) : !promoCodes.length ? (
          <EmptyCouponsAndPromoCodes />
        ) : (
          <PromoCodeList promoCodes={promoCodes} />
        )}
      </Container>
    </IonPage>
  );
};

export default PromoCodesAndCoupons;
